import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { getSubscriptionList } from '../../api/subscription'
import { notifications } from '@mantine/notifications';

function useGetSubscription() {


    const SubscriptionQuery = useQuery({
        queryFn: () => getSubscriptionList({

        }),
        queryKey: ["Subscription_list"],

        placeholderData: (previousData) => previousData, // identity function with the same behaviour as `keepPreviousData`,


    });

    const { isPending, isFetching } = SubscriptionQuery
    useEffect(() => {
        if (!isPending && !isFetching) {
            notifications.clean()
        }

    }, [isPending, isFetching]);





    return {
        SubscriptionQuery,
    }
}

export default useGetSubscription
